import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/unidades/getIngresosUnidad.php';

export default function getIngresosUnidad({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}